import axios from '@/plugins/axios';

export default {
  async GetDiscount({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`discounts/${id}`)
        .then((resp) => {
          commit('SET_BREADCRUMB', resp.data.reference_number, {
            root: true,
          });
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async CreateDiscount({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('discounts', payload)

        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async UpdateDiscount({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`discounts/${payload.id}`, payload.body)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async SoftDeleteDiscount({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`discounts/${Id}/soft-delete`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
